export const routes = {
  getOrgInfo: () => `/kindergarten/organization/info`,
  getPortfolio: () => `/kindergarten/organization/portfolio`,
};
